import { render, staticRenderFns } from "./DirectCandidates.vue?vue&type=template&id=709afed6"
import script from "./DirectCandidates.vue?vue&type=script&lang=js"
export * from "./DirectCandidates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports